<template>
  <div>
    <transition name="fade">
      <b-card title="Ingrese Informacion" v-show="showCard">
        <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" v-if="show">
          <b-form-group
            id="label0"
            label="Tipo de Limpieza"
            label-for="input0"
            description="tipo de limpieza que se a ejecutado "
          >
            <b-form-select
              v-model="formd.tipo"
              :options="optionTipo"
              required
            />
          </b-form-group>
          <b-form-group
            id="label12"
            label="Estado pago"
            label-for="input12"
            description="Estado pago de lavado"
          >
            <b-form-input
              id="input12"
              type="number"
              v-model="formd.estado"
              :required="true"
            />
          </b-form-group>
          <b-form-group
            v-show="formd.tipo === 'No lavada'"
            id="label8"
            label="Causa no lavado"
            label-for="input8"
            description="La causa por la cual no se lavo el tramo"
          >
            <b-form-select
              id="input8"
              v-model="formd.causa"
              :options="optionsCausas"
              :required="formd.tipo === 'No lavada'"
            />
          </b-form-group>

          <b-form-group
            id="label11"
            label="Localidad"
            label-for="input9"
            description="Localidad que se encuentra el tramo"
          >
            <b-form-textarea
              id="input11"
              type="text"
              v-model="formd.localidad"
              rows="1"
              max-rows="2"
              :required="true"
            />
          </b-form-group>

          <b-form-group
            id="label16"
            label="Zona"
            label-for="input16"
            description="Selecione una zona"
          >
            <b-form-select
              id="input16"
              v-model="formd.zona"
              :options="optionsZonas"
              :required="true"
            />
          </b-form-group>

          <b-form-group
            id="label1"
            label="Longitud en terreno"
            label-for="input1"
            description="Metros que se lavo."
            v-show="formd.tipo !== 'No lavada'"
          >
            <b-form-input
              id="input1"
              type="number"
              v-model="formd.lavado"
              :required="formd.tipo !== 'No lavada'"
              placeholder="lavado"
            />
          </b-form-group>
          <b-form-group
            v-show="formd.tipo !== 'No lavada'"
            id="label2"
            label="Fecha de lavado"
            label-for="input2"
          >
            <datepicker id="input2" :value="formd.fecha" v-model="formd.fecha" :required="formd.tipo !== 'No lavada'"></datepicker>
          </b-form-group>
          <b-form-group
            v-show="formd.tipo !== 'No lavada'"
            id="label4"
            label="Operadores"
            label-for="input4"
            description="Operador del camion"
          >
            <b-form-select
              id="input4"
              v-model="formd.operador"
              :options="optionsOperadores"
              @change="patenteToOperador"
              :required="formd.tipo !== 'No lavada'"
            />
          </b-form-group>
          <b-form-group
            id="label3"
            label="Patente"
            label-for="input3"
            v-show="formd.tipo !== 'No lavada'"
            description="Patente del camion"
          >
            <b-form-select
              id="input3"
              v-model="formd.patente"
              :options="optionsPatentes"
              :required="formd.tipo !== 'No lavada'"
            />
          </b-form-group>
          <b-form-group
            id="label5"
            label="Asistente"
            v-show="formd.tipo !== 'No lavada'"
            label-for="input4"
            description="Asistente del operador"
          >
            <b-form-input
              id="input5"
              type="text"
              v-model="formd.asistente"
              :required="formd.tipo !== 'No lavada'"
            />
          </b-form-group>

          <b-form-group
            id="label10"
            label="largo shape"
            v-show="formd.tipo !== 'No lavada'"
            label-for="input10"
            description="Largo del shape"
          >
            <b-form-input
              id="input10"
              type="text"
              v-model="formd.shapel"
              :required="true"
            />
          </b-form-group>
          <b-form-group
            id="label9"
            label="Observacion"
            label-for="input9"
            description="Adjuntar informacion sobre lavado"
          >
            <b-form-textarea
              id="input9"
              type="text"
              v-model="formd.observacion"
              rows="3"
              max-rows="6"
              :required="formd.tipo === 'No lavada'"
            />
          </b-form-group>
          <!--sep-->
          <hr style="border-color:red;" />
          <b-form-group
            id="label6"
            label="Ispección"
            label-for="input6"
            description="indicar si se realizo la inspeccion televisiva"
          >
            <b-form-select
              id="input6"
              v-model="formd.inspeccion"
              :options="optionitv"
            />
          </b-form-group>
          <b-form-group
            id="label7"
            label="Metros de itv"
            label-for="input7"
            v-show="formd.inspeccion"
            description="Los metros que se inspeccionaron"
          >
            <b-form-input
              id="input7"
              type="text"
              v-model="formd.metrositv"
              :required="formd.inspeccion"
            />
          </b-form-group>

          <b-form-group
            id="label14"
            label="Observacion ITV"
            label-for="obsitv"
            v-show="formd.inspeccion"
            description="Adjuntar informacion sobre ITV"
          >
            <b-form-input
              id="obsitv"
              type="text"
              v-model="formd.preinforme_obsitv"
            />
          </b-form-group>
          <b-form-group
            v-show="formd.inspeccion"
            id="label15"
            label="Fecha de ispeccion "
            label-for="input15"
          >
            <datepicker id="input15" :value="formd.preinforme_fechaitv" v-model="formd.preinforme_fechaitv" :required="formd.inspeccion"></datepicker>
          </b-form-group>
          <b-form-group
            id="label13"
            label="Estado pago"
            v-show="formd.inspeccion"
            label-for="input13"
            description="Estado pago de ITV"
          >
            <b-form-input
              id="input13"
              type="number"
              v-model="formd.estadoitv"
              :required="formd.inspeccion"
            />
          </b-form-group>

          <b-button type="submit" variant="primary">Enviar</b-button>
          <b-button class="float-right" type="reset" variant="danger"
            >Limpiar</b-button
          >
        </b-form>
      </b-card>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-console */
import Http from "../Http";
import store from "../store/";
import Eventbus from '../Bus';
import Datepicker from 'vuejs-datepicker';

export default {
  name: "form-supInforme",
  props: ["showCard", "tramo", "subcuenca","state","shapel","orden"],
  components: {
    Datepicker
  },
  watch: {
    showCard() {
      console.log("cambio");
      this.onReset();
    }
  },
  data: () => ({
    show: true,
    optionTipo: [
      { value: null, text: "Seleccione una opcion" },
      { value: "Hidráulica", text: "Hidráulica" },
      { value: "No lavada", text: "No lavada" }
    ],
    optionitv: [
      { value: null, text: "Seleccione una opcion" },
      { value: true, text: "SI" },
      { value: false, text: "NO" }
    ],
    patentes: [],
    operadoresLtv: [],
    zonas:[],
    causas: [],
    preff:0,
    formd: {
      tipo: null,
      lavado: null,
      fecha: null,
      patente: null,
      operador: null,
      asistente: null,
      estado: null,
      metrositv: null,
      observacion: "",
      causa: null,
      inspeccion: null,
      shapel: null,
      localidad:null,
      estadoitv:null,
      preinforme_obsitv:"",
      preinforme_fechaitv:null,
      zona:null
    }
  }),
  computed: {
    optionsPatentes() {
      return this.patentes
        .filter(x => x.patente_id !== 12)
        .map(x => ({
          value: x.patente_id,
          text: x.patente_nombre
        }));
    },
    optionsOperadores() {
      return this.operadoresLtv
        .filter(x => x.operador_id !== 12)
        .map(x => ({
          value: x.operador_id,
          text: x.operador_nombre
        }));
    },
    optionsCausas() {
      return this.causas
        .filter(x => x.causa_id !== 19)
        .map(x => ({
          value: x.causa_id,
          text: x.causa_nombre
        }));
    },
    optionsZonas() {
      return this.zonas
        .map(x => ({
          value: x.zona_id,
          text: x.zona_nombre
        }));
    },
  },
  mounted: function() {
    Http.Http()
      .get(`Preinf/Patentes`)
      .then(resp => {
        this.patentes = resp.data;
        console.log(resp.data);
      })
      .catch(err => {
        console.log(err);
      });
    Http.Http()
      .get("Preinf/Causalvd")
      .then(resp => {
        this.causas = resp.data;
      })
      .catch(err => {
        console.log(err);
      });
    Http.Http()
      .get("Preinf/Zona")
      .then(resp => {
        console.log(resp);
        this.zonas = resp.data;
      })
      .catch(err => {
        console.log(err);
      });
    Http.Http()
      .get("Preinf/Operadoreslvd")
      .then(resp => {
        this.operadoresLtv = resp.data;
      })
      .catch(err => {
        console.log(err);
      });
    if(this.state === 1 || this.state === 4){
      Http.Http()
        .get(`Preinf/Tramo/${this.tramo}`)
        .then(resp => {
          setTimeout(()=>{
            console.log(resp.data);
            this.formd.tipo = resp.data.preinforme_tipo;
            this.formd.lavado = resp.data.preinforme_longitud;
            this.formd.fecha = new Date(resp.data.preinforme_fecha);
            this.formd.patente = resp.data.preinforme_patente;
            this.formd.operador = resp.data.preinforme_operador;
            this.formd.asistente = resp.data.preinforme_asistente;
            this.formd.observacion = resp.data.preinforme_observacionlvd;
            this.formd.inspeccion = resp.data.preinforme_inspeccion;
            this.formd.metrositv = resp.data.preinforme_metrositv;
            this.formd.causa= resp.data.causa_id;
            this.preff = resp.data.preinforme_id;
            this.formd.localidad = resp.data.reporte_localidad;
            this.formd.estado = resp.data.preinforme_estado;
            this.formd.estadoitv = resp.data.preinforme_estadoitv;
            this.formd.preinforme_obsitv =resp.data.preinforme_obsitv;
            this.formd.preinforme_fechaitv = (resp.data.preinforme_inspeccion)?resp.data.preinforme_fechaitv:new Date();
            this.formd.zona = resp.data.zona_id;
          },500);

        })
        .catch(err => {
          console.log(err);
        });
    }
    this.formd.shapel = this.shapel;
  },
  methods: {
    onSubmit() {
      let data;
      if (this.formd.inspeccion == null || !this.formd.inspeccion) {
        this.formd.inspeccion = false;
        this.formd.metrositv = 0;
        this.formd.estadoitv = 0;
      }
      if (this.formd.tipo === "No lavada") {
        data = {
          preinforme_tipo: this.formd.tipo,
          causa_id: this.formd.causa,
          preinforme_fecha: new Date(),
          preinforme_observacionlvd: this.formd.observacion,
          tramo_identifica: this.tramo,
          subcuenca_id: this.subcuenca,
          preinforme_inspeccion: this.formd.inspeccion,
          preinforme_metrositv: this.formd.metrositv,
          user_id: store.state.User.CurrentUser.user_id,
          reporte_shapel: this.formd.shapel,
          reporte_orden: this.orden,
          reporte_localidad: this.formd.localidad,
          preinforme_estado: this.formd.estado,
          preinforme_obsitv:this.formd.preinforme_obsitv,
          zona_id:this.formd.zona
        };
      } else {
        this.formd.causa = 0;
        data = {
          preinforme_tipo: this.formd.tipo,
          preinforme_longitud: this.formd.lavado,
          preinforme_fecha: this.formd.fecha,
          preinforme_patente: this.formd.patente,
          preinforme_operador: this.formd.operador,
          preinforme_asistente: this.formd.asistente,
          preinforme_observacionlvd: this.formd.observacion,
          tramo_identifica: this.tramo,
          subcuenca_id: this.subcuenca,
          preinforme_inspeccion: this.formd.inspeccion,
          preinforme_metrositv: this.formd.metrositv,
          user_id: store.state.User.CurrentUser.user_id,
          reporte_orden: this.orden,
          reporte_shapel: this.formd.shapel,
          reporte_localidad: this.formd.localidad,
          preinforme_estado: this.formd.estado,
          preinforme_estadoitv: this.formd.estadoitv,
          preinforme_obsitv:this.formd.preinforme_obsitv,
          zona_id:this.formd.zona
        };
        if(this.formd.inspeccion){
          Object.defineProperty(data,"preinforme_fechaitv",this.formd.preinforme_fechaitv);
        }

      }
      console.log(data);
      //preinforme_id:
      if(this.state === 1 || this.state === 4){
        Http.Http()
          .put(`Preinf/${this.preff}`, data)
          .then(resp => {
            console.log(resp);
            alert("Se Actualizaron los datos de forma correcta");
            Eventbus.$emit('feature', this.tramo);
            this.onReset();
          })
          .catch(err => {
            console.log(err);
          });
      }
      else {
        Http.Http()
          .post(`Preinf/${store.state.User.CurrentUser.role_id}`, data)
          .then(resp => {
            console.log(resp);
            Eventbus.$emit('feature', this.tramo);
            alert("Se Ingresaron los datos de forma correcta");
            this.onReset();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    onReset() {
      this.formd.tipo = null;
      this.formd.lavado = null;
      this.formd.fecha = null;
      this.formd.operador = null;
      this.formd.patente = null;
      this.formd.asistente = null;
      this.formd.inspeccion = null;
      this.formd.metrositv = null;
      this.formd.causa = null;
      this.formd.preinforme_obsitv="";
      this.formd.preinforme_fechaitv=null;
      this.formd.estadoitv = null;
      this.formd.localidad = null;
      this.preff = null;
      this.formd.observacion = null;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    patenteToOperador() {
      let patente = this.operadoresLtv.find(
        x => x.operador_id === this.formd.operador
      );
      this.formd.patente = patente.patente_id;
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
